import React from "react"
import axios from "axios"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"

import { PageContainer, OfferDetail } from "../../components"
import { fail } from "../../actions"

// Reseller ordering a new product for an allocated customer.
// Catalog comes from the reseller endpoint (target customer's limits apply);
// the order goes through /ordersUser at default (erp) pricing.
class OfferDetailReseller extends React.Component {
  state = { fetching: true, nceoffers: [] }

  componentDidMount = async () => {
    const { customerId } = this.props.match.params
    try {
      const { data } = await axios.get(
        `/resellercustomers/${customerId}/nceoffers`
      )
      this.setState({ fetching: false, nceoffers: data.nceoffers || [] })
    } catch (error) {
      this.props.fail(null, error).then(() => this.setState({ fetching: false }))
    }
  }

  order = async (data) => {
    await axios.post(`/ordersUser`, {
      ...data,
      customerId: this.props.match.params.customerId,
    })
  }

  render() {
    const product = this.state.nceoffers.find(
      (offer) => offer._id === this.props.match.params.offerId
    )
    if (!this.state.fetching && !product) {
      return <h3 className="text-center">Not Found</h3>
    }
    return (
      <PageContainer
        title={product ? product.productTitle : ""}
        loading={this.state.fetching}
      >
        {product && <OfferDetail offer={product} order={this.order} />}
      </PageContainer>
    )
  }
}

export default connect(null, { fail })(withTranslation()(OfferDetailReseller))
